import { strings } from 'res';
import { CashHandoverIcon, CommandCenterIcon, ReportIcon, DashboardIcon, SettingIcon, SLAIcon, DeliveryIcon, OrderIcon  } from "../assets/svg/icon";

const dashBoardNavTree = [{
  key: "Home",
  path: strings.navigation.path.dashboard,
  title: "Home",
  breadcrumb: false,
  submenu: [
    {
      key: "Dashboard",
      path: strings.navigation.path.dashboard,
      title: "Dashboard",
      icon: DashboardIcon,
      breadcrumb: false,
      submenu: []
    },
    {
      key: "Tambah Device",
      path: strings.navigation.path.surat_masuk,
      title: "Tambah Device",
      icon: DeliveryIcon,
      breadcrumb: false,
      submenu: []
    },
    {
      key: "Tambah Sensor",
      path: strings.navigation.path.surat_masuk,
      title: "Tambah Sensor",
      icon: SLAIcon,
      breadcrumb: false,
      submenu: []
    },
    {
      key: "Report",
      path: strings.navigation.path.laporan,
      title: "Report",
      icon: ReportIcon,
      breadcrumb: false,
      submenu: []
    },
    {
      key: "Token",
      path: strings.navigation.path.pengguna,
      title: "Token",
      icon: CommandCenterIcon,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const ControlTree = [{
  key: "Pengaturan",
  path: strings.navigation.path.settings,
  title: "Pengaturan",
  breadcrumb: false,
  submenu: [
    {
      key: "Pengaturan",
      path: strings.navigation.path.settings,
      title: "Pengaturan",
      icon: SettingIcon,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const navigationConfig = [
  ...dashBoardNavTree,
  ...ControlTree,
]

export default navigationConfig;